<se-fe-modal-button [seFeDataButton]="{icon: true}" (seFeButtonAction)="detailModal.open($event)">
  <se-fe-icon
    seFeModalIcon
    seFeDataName="pencil_fill"
    seFeDataSize="500"
    seFeDataColor="default"
    seFeDataAriaLabel="edit"></se-fe-icon>
</se-fe-modal-button>

<se-fe-modal seFeDataSize="large" #detailModal [seFeDataActions]="detailModalButtons" (seFeClose)="resetForm()">
  <div seFeModalHeader>
    <se-fe-modal-header [seFeDataTitle]="'Edit Product details'" id="modal-header"></se-fe-modal-header>
  </div>

  <se-fe-modal-content id="modal-content">
    <form [formGroup]="form" novalidate>
      <se-fe-grid seFeGridOpts="snug">
        <se-fe-grid-cell seFeGridOpts>
          <se-fe-form-field class="modal-form-field" [seFeDataConfig]="productNameConfig">
            <se-fe-form-field-text formControlName="name" seFeDataAutoComplete="off"></se-fe-form-field-text>
          </se-fe-form-field>
          <se-fe-form-field class="modal-form-field" [seFeDataConfig]="productPriceConfig">
            <se-fe-form-field-text
              formControlName="price"
              seFeDataAutoComplete="off"
              seFeDataType="number"
              seFeDataInputMode="numeric">
              <span seFeFormFieldTextBefore>$</span>
            </se-fe-form-field-text>
          </se-fe-form-field>
          <!-- <se-fe-form-field class="modal-form-field" [seFeDataConfig]="itemNumberConfig">
          <se-fe-form-field-text formControlName="itemNumber" seFeDataAutoComplete="off"></se-fe-form-field-text>
        </se-fe-form-field> -->
          <se-fe-form-field [seFeDataConfig]="productDescLabel">
            <se-fe-wysiwyg formControlName="description" aria-label="product description"></se-fe-wysiwyg>
          </se-fe-form-field>
          @if (descriptionCtrl.hasError('maxlength')) {
            <span class="se-fe-wysiwyg-error se-fe-form-control-errors">
              Description exceeds the maximum allowed length.
            </span>
          }
          @if (error()) {
            <se-fe-alert seFeDataType="error">
              {{ error() }}
            </se-fe-alert>
          }
        </se-fe-grid-cell>
      </se-fe-grid>
    </form>
  </se-fe-modal-content>
</se-fe-modal>
